<template>
  <div>
    <div style="float: left">
      <b v-if="target == 'account_rate'">Account Creation Rate (per {{per_ledger_second_title}})</b>
      <b v-else-if="target == 'new_accounts'">Total Number of Accounts Created</b>

      <span id="account_rate_stats">ⓘ</span>
      <StatsPopover target="account_rate_stats"
                    :stats="stats"
                    :data="data"
                    @toggle="toggle_stat($event)"/>
    </div>

    <div id="series_toggle" style="float: right">
      <b-button-group>
        <b-button variant="primary"
                  v-bind:pressed="target == 'account_rate'"
                  v-on:click="target = 'account_rate'">
                    Rate
        </b-button>

        <b-button variant="primary"
                  v-bind:pressed="target == 'new_accounts'"
                  v-on:click="target = 'new_accounts'">
                    #
        </b-button>
      </b-button-group>
    </div>

    <div style="clear: both"></div>

    <div style="margin-top: 10px">
      <apexchart id="report_metric_accounts"
                 type=line
                 v-bind:options="accounts_options"
                 :series="series" />
     </div>
  </div>
</template>

<script>
import util from '../../../util';

import StatsPopover from './StatsPopover'

const LedgersSecondsConverter = require('./ledgers_seconds_converter').default
const StatsCalculator         = require('./stats_calculator').default

export default {
  name: 'MetricsAccountRate',

  mixins : [LedgersSecondsConverter, StatsCalculator],

  components : {StatsPopover},

  props : {
    subreport : {
      type : Boolean,
      defalt : false
    }
  },

  data : function(){
    return {
      target : 'account_rate',
       stats : ['average']
    };
  },

  computed : {
    period : function(){
      return this.subreport ? this.$store.state.report.selected.subperiod :
                              this.$store.state.report.period;
    },

    data : function(){
      const data = this.subreport ? this.$store.state.report.subreport :
                                    this.$store.state.report.data;

      if(this.target == 'account_rate' && this.per_second)
        return this.ledgers_to_seconds(data[this.target],
                                       data['ledgers_closed'],
                                       this.period);

      return data[this.target];
    },

    series : function(){
      var series = [{
        name : this.target,
        data: Object.values(this.data)
      }];

      if(this.stat_enabled('average'))
        series.push(this.average_series);

      if(this.stat_enabled('median'))
        series.push(this.median_series);

      return series;
    },

    accounts_options : function(){
      return {
        chart: {
           animations: {
                enabled: true,
                easing: 'easeinout',
                speed: 100,
                animateGradually: {
                    enabled: true,
                    delay: 100
                },
                dynamicAnimation: {
                    enabled: true,
                    speed: 150
                }
            }
        },
        xaxis : {
          type: 'datetime',
          categories : Object.keys(this.data)
        },

        tooltip : {
          x : { show : false, format : this.period == '86400' ? 'yyyy-MM-dd' : "yyyy-MM-dd HH:mm" }
        },

        yaxis : {
          labels : {
            formatter : function(v){
              var round = this.target == 'account_rate' ? 3 : 0;
              return util.delim_value(util.round_value(v, round));
            }.bind(this)
          }
        }
      };
    }
  }
}
</script>

<style scoped>
#account_rate_stats{
  margin-left: 5px;
  cursor: pointer;
}

#series_toggle{
  font-size: 0.7em;
}
</style>
